"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterpolationMode = exports.ExtrapolationMode = exports.CalendarAdjustment = exports.RiskType = exports.MainConstituentAssetClass = void 0;
var MainConstituentAssetClass;
(function (MainConstituentAssetClass) {
    MainConstituentAssetClass["Swap"] = "Swap";
    MainConstituentAssetClass["Futures"] = "Futures";
})(MainConstituentAssetClass || (exports.MainConstituentAssetClass = MainConstituentAssetClass = {}));
var RiskType;
(function (RiskType) {
    RiskType["InterestRate"] = "InterestRate";
})(RiskType || (exports.RiskType = RiskType = {}));
var CalendarAdjustment;
(function (CalendarAdjustment) {
    CalendarAdjustment["Weekend"] = "Weekend";
    CalendarAdjustment["Calendar"] = "Calendar";
})(CalendarAdjustment || (exports.CalendarAdjustment = CalendarAdjustment = {}));
var ExtrapolationMode;
(function (ExtrapolationMode) {
    ExtrapolationMode["None"] = "None";
    ExtrapolationMode["Constant"] = "Constant";
    ExtrapolationMode["Linear"] = "Linear";
})(ExtrapolationMode || (exports.ExtrapolationMode = ExtrapolationMode = {}));
var InterpolationMode;
(function (InterpolationMode) {
    InterpolationMode["CubicDiscount"] = "CubicDiscount";
    InterpolationMode["CubicRate"] = "CubicRate";
    InterpolationMode["CubicSpline"] = "CubicSpline";
    InterpolationMode["Linear"] = "Linear";
    InterpolationMode["Log"] = "Log";
    InterpolationMode["ForwardMonotoneConvex"] = "ForwardMonotoneConvex";
})(InterpolationMode || (exports.InterpolationMode = InterpolationMode = {}));
